<template>
  <div class="return-info">
    <div class="title">商品鑑賞期</div>
    <div class="mt-2">
      <p>
        Loft29 Collection依照消費者保護法規定,Loft29 Collection 線上購物網站消費者均享有商品到貨七天猶豫期之權益,
        是指從商品到貨七天內為商品猶豫期(七天包含假日),在鑑賞期內若有商品瑕疵或損壞情形發生而要求退換貨,本公司可以接受退換貨的申請,
        為保障您的權益,請務必於商品猶豫期間(七天內)內提出,並且將產品連同包裝盒、說明書等完整包裝及商品內容寄出,
        終止日則以運送業單據或郵戳日期為準(若超過此期間視同驗收完成,不得退貨)。退貨商品須為全新未經拆封使用並保留原始完整包裝,
        本公司可再次轉賣或退還原廠之狀態,否則恕不接受退貨。本公司接到顧客的退換貨要求後,會立刻進行處理事宜。
      </p>
      <p>
        下列情形恕無法接受退換貨:
      </p>
      <p>
        <span>超過七天的商品鑑賞期。</span>
        <ul>
          <li>外包裝紙盒輕微的摺痕或因搬運過程中嚴重之碰撞,影響產品本身品質。</li>
          <li>產品本身因人為污損、故障、損毀、磨損、擦傷、刮傷、髒污,包裝破損不完整,或是發票、附配件不齊者,怒不接受退貨。</li>
          <li>產品所附之相關贈品及相關物品遺失或毀損。</li>
          <li>產品已拆封或經使用,無法再轉售或其他影響產品完整性,導致無法販售或向原廠退貨者。</li>
          <li>智慧財產權類的商品,例如CD、書籍雜誌等,或是商品描述中有特別標示「拆封或使用後即無法退貨」的商品。</li>
          <li>特殊訂製商品(如沙發、地毯等)等高單價商品於接單後開始製作、經客戶要求變換原廠電壓之商品視為訂製商品,我們收到訂單後會與您再次確認訂單內容,確定訂購後恕無法退貨或取消訂單。</li>
        </ul>
      </p>
    </div>
    <div class="title mt-3">退換貨需知</div>
    <div class="mt-2">
      <p>
        <ol>
          <li>
            如因本公司的疏失(送錯商品、運送毀損、商品有瑕疵等)造成您退/換貨,我們會負擔退回商品的運費/郵資,並將原商品價格全額退還或是更換新商品給您。
            若係因個人因素退/換貨(例如樣式不喜歡,與想像中有出入等等原因),則必須請你負擔退回原出貨地點的運費/郵資。若您是使用信用卡付款,
            我們將採用退刷方式直接將款項退回您信用卡帳戶中;若您是採用ATM轉帳付款,我們將採用轉帳方式直接將款項退回您的帳戶裡,當退款完成時,
            我們也會發送退款完成通知信通知您。
          </li>
          <li>
            <span>換貨程序:</span>
            <ol>
              <li class="mb-3">
                準備物品:<br>
                請您務必將商品及完整包裝,連同配件、贈品及發票,以原寄送時包裝再予以原封備妥。(請勿直接讓商品外彩盒粘貼宅配單或於外彩盒上書寫文字)。
              </li>
              <li class="mb-3">
                商品寄回:<br>
                請您將商品寄回本公司,並於信中清楚註記您的姓名、訂單編號、換貨原因、日間可聯絡之電話及收貨地址,以加速我們處理時效。
              </li>
              <li>
                重新配送:<br>
                待我們收到你欲換貨之完整商品後,將立即為您再次配送新品。《提醒您~從您寄出換貨商品到您收到新品約需9~12個工作天》換貨之原因若為本公司的疏失
                (送錯商品、運送毀損、商品本身自有瑕疵)造成您換貨,相關費用支出由本公司負擔。換貨之原因若非本公司產品有瑕疵或可歸責於本公司如送錯商品等,
                其相關費用如運費、掛號或匯款等相關費用則須由客戶自行負擔。
              </li>
            </ol>
          </li>
          <li>
            <span>退貨方式:</span>
            <ol>
              <li class="mb-3">
                準備物品:<br>
                請您務必將商品及完整包裝,連同配件、贈品及發票,以原寄送時包裝再予以原封備妥。(請勿直接讓商品外彩盒粘貼宅配單或於外彩盒上書寫文字)。
              </li>
              <li class="mb-3">
                商品寄回:<br>
                請您將商品寄回本公司,並於信中清楚註記您的姓名、訂單編號、退貨原因,以加速我們處理時效。
              </li>
              <li>
                <span>退款:本公司收到退貨的產品後會立即交由會計人員處理退貨事宜。</span>
                <ul>
                  <li>若您為晶片金融卡ATM轉帳/臨櫃滙款,請將您欲轉入之銀行、帳號提供給我們。</li>
                  <li>若您為信用卡方式付款,後續款項將會直接退回您的信用卡帳戶內,因銀行處理時效約5至7個工作天,請依您的信用卡結帳日判斷,刷退款項可能列於本月或次月的帳單。</li>
                  <li>退貨之原因若為本公司的疏失(送錯商品、運送毀損、商品本身自有瑕疵)造成您退/換貨,相關費用支出由本公司負擔。</li>
                  <li>退貨之原因若非本公司產品有瑕疵或可歸責於本公司如送錯商品等,其相關費用如運費、掛號或匯款等相關費用由貨款中扣除。</li>
                </ul>
              </li>
            </ol>
          </li>
        </ol>
      </p>
      <p>
        請注意:所有商品一經拆封即無法退貨,只能夠針對瑕疵商品換貨。( 七天內若是未經拆封則可申請退貨) 瑕疵產品之更換,
        請消費者將所訂購之商品完整性寄回本公司,且以一次為限,本公司客服人員會收到產品後會立即為您處理。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReturnInfo'
}
</script>

<style scoped>
.title {
  font-size: 1.2rem;
  font-weight: 700;
  font-family: 'Noto Serif TC', serif;
}
img {
  height: 50px;
}
ol ol {
  list-style: lower-alpha;
}
</style>
